"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/icon/style");
var _icon = _interopRequireDefault(require("antd/lib/icon"));
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _SingleGroupChat = _interopRequireDefault(require("./SingleGroupChat"));
var _components = require("../../../components");
var _utils = require("../../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var SingleGroupChatWidget = function SingleGroupChatWidget(_ref) {
  var chatClient = _ref.chatClient,
    groupId = _ref.groupId,
    globalBan = _ref.globalBan,
    isChatRendered = _ref.isChatRendered,
    isChatVisible = _ref.isChatVisible,
    setIsChatVisible = _ref.setIsChatVisible,
    owner = _ref.owner;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    channel = _useState2[0],
    setChannel = _useState2[1];
  var moderator = (0, _utils.personName)(owner);
  var _useState3 = (0, _react.useState)(isChatVisible),
    _useState4 = _slicedToArray(_useState3, 2),
    chatVisible = _useState4[0],
    setChatVisible = _useState4[1];
  (0, _react.useEffect)(function () {
    if (isChatVisible !== chatVisible) {
      setChatVisible(isChatVisible);
    }
  }, [isChatVisible]);
  var changeChatVisibility = (0, _react.useCallback)(function () {
    var isVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (setIsChatVisible) {
      setIsChatVisible(isVisible);
    } else {
      setChatVisible(isVisible);
    }
  }, [setChatVisible, setIsChatVisible]);
  var unread = channel === null || channel === void 0 ? void 0 : channel.countUnread();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_button.default, {
    className: "flex absolute w-[100px] h-[40px] rounded-[8px] border-0 bg-red-100 border-0 text-white items-center justify-center md:z-[106] left-[37px] bottom-[137px] md:left-[83px] md:bottom-[107px] hover:bg-red-100 hover:text-white focus:text-white focus:bg-red-100",
    onClick: function onClick() {
      changeChatVisibility(!chatVisible);
    }
  }, /*#__PURE__*/_react.default.createElement(_components.Icon, {
    type: chatVisible ? 'cloud-active' : 'cloud-inactive',
    size: 8,
    viewBoxSize: 24,
    className: "mt-[8px]"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "ml-[5px]"
  }, "Chat"), Boolean(unread) && /*#__PURE__*/_react.default.createElement(_components.Icon, {
    style: {
      position: 'relative',
      left: '8px',
      top: '-5px'
    },
    type: "white-dot",
    size: 8,
    viewBoxSize: 8
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('chat-container', {
      'chat-container__hidden': !chatVisible
    })
  }, isChatRendered && /*#__PURE__*/_react.default.createElement("div", {
    className: "single-group-chat"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "header-line flex flex-row w-100 items-center h-[56px]"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "moderator-info w-5/6 justify-center content-start"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-body-sm-regular text-grey-50 pl-[8px] md:pl-[21px]"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "inline-block md:hidden"
  }, "\u2022"), " Moderator"), /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-body-sm-regular text-grey-50 info-divider mx-[12px]"
  }, "|"), /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-body-sm-medium text-green1-55 underline pl-[21px] md:pl-0"
  }, moderator)), /*#__PURE__*/_react.default.createElement("div", {
    className: "w-1/6 mr-[5px]"
  }, isChatVisible && /*#__PURE__*/_react.default.createElement(_button.default, {
    className: "chat-close-button float-right px-0 h-auto",
    onClick: function onClick() {
      changeChatVisibility(false);
    }
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: "close"
  })))), /*#__PURE__*/_react.default.createElement(_SingleGroupChat.default, {
    chatClient: chatClient,
    groupId: groupId,
    globalBan: globalBan,
    setChannel: setChannel
  }))));
};
var _default = SingleGroupChatWidget;
exports.default = _default;